<template>
  <settings-modal
    class="savings-account-rate-editor-modal t-savings-account-rate-editor-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >{{ title }}</span>

    <v-layout row>
      <v-flex xs6>
        <date-picker
          v-model="form.createdAt"
          style="margin-top: -13px"
          label="Created date"
          :disabled="hasSavingsAccountRate"
          :error-messages="getValidationErrorMessage('createdAt')"
        />
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs6>
        <v-select
          v-model="form.currency"
          label="Currency"
          disabled
          :items="['EUR']"
          :error-messages="getValidationErrorMessage('currency')"
        />
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs6>
        <v-text-field
          v-model="form.rate"
          type="number"
          label="Rate"
          :error-messages="getValidationErrorMessage('rate')"
        />
      </v-flex>
    </v-layout>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || loading"
        @click="onConfirmButtonClick"
      >{{ confirmButtonText }}</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  // Events
  import { EVENT_SAVINGS_ACCOUNT_RATE_CHANGE } from '@/events/savingsAccount'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import SavingsAccountApi from '@/services/Api/SavingsAccountApi'

  // Mixins
  import form from '@/mixins/form'
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import DatePicker from '@/components/ui/DatePicker'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'SavingsAccountRateEditorModal',
    components: {
      SettingsModal,
      DatePicker,
      ErrorAlert
    },
    mixins: [form, modal, flashMessages],
    data () {
      return {
        form: {
          createdAt: null,
          currency: 'EUR',
          rate: null
        },
        saveSavingsAccountRateApiRequest: new ApiRequest(SavingsAccountApi.saveRate)
      }
    },
    computed: {
      hasSavingsAccountRate () {
        return this.modalData.savingsAccountRate != null
      },
      title () {
        return `${this.hasSavingsAccountRate ? `Edit ${this.currency}` : 'Add'} rate`
      },
      confirmButtonText () {
        return this.hasSavingsAccountRate ? 'save changes' : 'add rate'
      },
      error () {
        return this.saveSavingsAccountRateApiRequest.error
      },
      loading () {
        return this.saveSavingsAccountRateApiRequest.loading
      },
      requiredFields () {
        return Object.keys(this.form)
      },
      currency () {
        return this.modalData.savingsAccountRate.currency
      }
    },
    created () {
      if (this.hasSavingsAccountRate) {
        this.setFormData(this.modalData.savingsAccountRate)
      }
    },
    methods: {
      onConfirmButtonClick () {
        this.saveSavingsAccountRateApiRequest
          .execute(this.parsedFormInput)
          .then(() => {
            this.$eventHub.$emit(EVENT_SAVINGS_ACCOUNT_RATE_CHANGE)

            this.showSuccessFlashMessage(
              this.hasSavingsAccountRate
                ? 'Rate has been successfully edited.'
                : 'Rate has been successfully added.'
            )
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
